import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import moment from 'moment';
import DatePickerFromTo from 'containers/Forms/Partials/DatePickerFromTo';
import { createMeetingTimeBlocks, updateMeetingTimeBlock } from 'actions/timeblocks';
import { Button } from '@haldor/ui';

var CreateTimeBlocks = /*#__PURE__*/function (_Component) {
  _inherits(CreateTimeBlocks, _Component);

  var _super = _createSuper(CreateTimeBlocks);

  function CreateTimeBlocks(props) {
    var _this;

    _classCallCheck(this, CreateTimeBlocks);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var translate;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              translate = _this.props.translate;
              return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
                  var obj;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          obj = {
                            meetingId: _this.props.reference.id,
                            startTime: moment.utc(_this.state.dates.start).local().format(),
                            endTime: moment.utc(_this.state.dates.end).local().format()
                          };

                          if (!(_this.props.initialValues == null)) {
                            _context2.next = 7;
                            break;
                          }

                          _context2.next = 4;
                          return _this.props.createMeetingTimeBlocks(_this.props.reference.id, [obj]);

                        case 4:
                          _this.props.onClose();

                          _context2.next = 11;
                          break;

                        case 7:
                          obj.id = _this.props.initialValues.id;
                          _context2.next = 10;
                          return _this.props.updateMeetingTimeBlock(_this.props.reference.id, obj);

                        case 10:
                          _this.props.onClose();

                        case 11:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (dates) {
      _this.setState({
        error: null
      });

      var filteredTimeBlocks = _this.props.meetingTimeBlocks.filter(function (item) {
        return _this.props.initialValues == null || item.id != _this.props.initialValues.id;
      });

      filteredTimeBlocks.map(function (item) {
        var startDateTime = moment.utc(item.startTime).local();
        var endDateTime = moment.utc(item.endTime).local();
        var currentDateTimeStart = moment.utc(dates.start).local();
        var currentDateTimeEnd = moment.utc(dates.end).local();

        if (currentDateTimeStart.isBetween(startDateTime, endDateTime) || currentDateTimeEnd.isBetween(startDateTime, endDateTime) || startDateTime.isBetween(currentDateTimeStart, currentDateTimeEnd)) {
          _this.setState({
            error: 'There is already a meeting occasion during this time.'
          });
        }
      });

      _this.setState({
        dates: dates
      });
    });

    _this.state = {
      dates: null,
      error: null
    };
    return _this;
  }

  _createClass(CreateTimeBlocks, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit,
          valid = _this$props.valid;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.onSubmit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(DatePickerFromTo, {
        timePicker: true,
        type: "timeblocks",
        onChange: this.onDateChange,
        values: this.props.initialValues,
        hideEndDate: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '.55rem',
          color: 'red'
        }
      }, this.props.translate(this.state.error)), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row submit spacing"
      }, /*#__PURE__*/React.createElement(Button, {
        style: {
          margin: 0
        },
        disabled: submitting || !valid || this.state.error,
        type: "save"
      }, this.props.initialValues == null ? this.props.translate('Create') : this.props.translate('save')), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))));
    }
  }]);

  return CreateTimeBlocks;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    translate: translate(state.Languages.translations),
    meetingTimeBlocks: state.TimeBlocks.meetingTimeBlocks,
    initialValues: ownProps.timeblock
  };
}

export default connect(mapStateToProps, {
  createMeetingTimeBlocks: createMeetingTimeBlocks,
  updateMeetingTimeBlock: updateMeetingTimeBlock
})(reduxForm({
  form: 'CreateTimeBlocks',
  destroyOnUnmount: true
})(CreateTimeBlocks));